// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__PbfiR","logo":"header_logo__1lPLH","nav":"header_nav__1orLG","navLink":"header_navLink__2nVV6"};